export default "__VITE_ASSET__DzyuEzb1__"